import { apiClient } from './apiClient'

export interface Video {
  id: string
  title: string
  description?: string
  url: string
  thumbnailUrl?: string
  topic: string
  durationSeconds: number
  views: number
  isPinned: boolean
  createdAt: string
  relatedVideos?: Video[]
}

class VideosApiService {
  /** Distinct topic values for the current request language (from Accept-Language). */
  async getTopics(): Promise<string[]> {
    const response = await apiClient.get<string[]>('/videos/topics')
    return Array.isArray(response.data) ? response.data : []
  }

  async getVideos(topic?: string, search?: string): Promise<Video[]> {
    const params = new URLSearchParams()
    if (topic) params.append('topic', topic)
    if (search) params.append('search', search)
    const url = `/Videos${params.toString() ? '?' + params.toString() : ''}`
    const response = await apiClient.get<Video[]>(url)
    return response.data
  }

  async getVideo(id: string): Promise<Video> {
    const response = await apiClient.get<Video>(`/Videos/${id}`)
    return response.data
  }

  async getMostViewed(count: number = 10): Promise<Video[]> {
    const response = await apiClient.get<Video[]>(`/Videos/most-viewed?count=${count}`)
    return response.data
  }
}

export const videosApi = new VideosApiService()


